export const showBadgeOnFavicon = () => {
  const favicons = document.querySelectorAll('.favicon');

  favicons.forEach(favicon => {
    if (!favicon.dataset.originalHref) {
      favicon.dataset.originalHref = favicon.href;
    }

    if (favicon.sizes && favicon.sizes[0]) {
      const newFileName = `/favicon-badge-${favicon.sizes[0]}.png`;
      favicon.href = newFileName;
    }
  });
};

export const initFaviconSwitcher = () => {
  const favicons = document.querySelectorAll('.favicon');

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      favicons.forEach(favicon => {
        if (favicon.sizes && favicon.sizes[0]) {
          const oldFileName = `/favicon-${favicon.sizes[0]}.png`;
          favicon.href = oldFileName;
        } else if (favicon.dataset.originalHref) {
          favicon.href = favicon.dataset.originalHref;
        }
      });
    }
  });
};
